var _excluded = ["rootClassName", "tag"],
  _excluded2 = ["rootClassName", "tag"],
  _excluded3 = ["rootClassName", "tag"],
  _excluded4 = ["rootClassName", "tag"],
  _excluded5 = ["rootClassName", "tag"],
  _excluded6 = ["rootClassName", "tag"],
  _excluded7 = ["rootClassName", "tag"],
  _excluded8 = ["rootClassName", "tag"],
  _excluded9 = ["rootClassName", "tag"],
  _excluded0 = ["rootClassName", "tag"],
  _excluded1 = ["rootClassName", "tag"],
  _excluded10 = ["rootClassName", "tag"],
  _excluded11 = ["rootClassName", "tag"],
  _excluded12 = ["rootClassName", "tag"],
  _excluded13 = ["rootClassName", "tag"],
  _excluded14 = ["rootClassName", "tag"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
//

import * as React from 'react';
import { css, StyleSheet, fontFamily, color } from "../../styles/theme";
var styles = StyleSheet.create({
  fontHeadline: {
    fontFamily: fontFamily.headline
  },
  fontBody: {
    fontFamily: fontFamily.body
  },
  fontDisplay: {
    fontFamily: fontFamily.display
  },
  bold: {
    fontFamily: fontFamily.bold
  },
  displayBold: {
    fontFamily: fontFamily.displayBold
  },
  weightLighter: {
    fontWeight: 'lighter'
  },
  weightNormal: {
    fontWeight: 'normal'
  },
  weightBold: {
    fontWeight: 'bold'
  },
  H1: {
    fontSize: '3rem',
    lineHeight: '3.75rem'
  },
  H1Xl: {
    fontSize: '3.75rem',
    lineHeight: '4.5rem'
  },
  H2: {
    fontSize: '2.125rem',
    lineHeight: '2.625rem'
  },
  H3: {
    fontSize: '1.5rem',
    lineHeight: '1.875rem'
  },
  H4: {
    fontSize: '1.25rem',
    lineHeight: '1.5rem'
  },
  P: {
    fontSize: '0.875rem',
    lineHeight: '1.5rem'
  },
  Strong: {
    fontSize: '0.875rem',
    lineHeight: '1.5rem'
  },
  Caption: {
    fontSize: '0.75rem',
    lineHeight: '1.125rem',
    color: color.textPrimary
  },
  Label: {
    fontSize: '0.75rem',
    lineHeight: '1.125rem',
    textTransform: 'uppercase'
  }
});

// We set font weight through both font-weight and font-family properties
// because if the browser fails to load font file, it will use fall back font family with the specified font-weight.
// https://graphicdesign.stackexchange.com/questions/74966/setting-font-weight-vs-bold-font-family-in-css-which-is-more-correct

export function H1(_ref) {
  var rootClassName = _ref.rootClassName,
    tag = _ref.tag,
    rest = _objectWithoutProperties(_ref, _excluded);
  var Tag = tag || 'h1';
  return /*#__PURE__*/React.createElement(Tag, _extends({}, css(rootClassName, styles.H1, styles.weightNormal, styles.fontHeadline), rest));
}
export function H2(_ref2) {
  var rootClassName = _ref2.rootClassName,
    tag = _ref2.tag,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  var Tag = tag || 'h2';
  return /*#__PURE__*/React.createElement(Tag, _extends({}, css(rootClassName, styles.H2, styles.weightNormal, styles.fontHeadline), rest));
}
export function H3(_ref3) {
  var rootClassName = _ref3.rootClassName,
    tag = _ref3.tag,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  var Tag = tag || 'h3';
  return /*#__PURE__*/React.createElement(Tag, _extends({}, css(rootClassName, styles.H3, styles.weightNormal, styles.fontHeadline), rest));
}
export function H4Light(_ref4) {
  var rootClassName = _ref4.rootClassName,
    tag = _ref4.tag,
    rest = _objectWithoutProperties(_ref4, _excluded4);
  var Tag = tag || 'h4';
  return /*#__PURE__*/React.createElement(Tag, _extends({}, css(rootClassName, styles.H4, styles.weightLighter, styles.fontHeadline), rest));
}
export function H4(_ref5) {
  var rootClassName = _ref5.rootClassName,
    tag = _ref5.tag,
    rest = _objectWithoutProperties(_ref5, _excluded5);
  var Tag = tag || 'h4';
  return /*#__PURE__*/React.createElement(Tag, _extends({}, css(rootClassName, styles.H4, styles.weightNormal, styles.fontBody), rest));
}
export function H4Bold(_ref6) {
  var rootClassName = _ref6.rootClassName,
    tag = _ref6.tag,
    rest = _objectWithoutProperties(_ref6, _excluded6);
  var Tag = tag || 'h4';
  return /*#__PURE__*/React.createElement(Tag, _extends({}, css(rootClassName, styles.H4, styles.weightBold, styles.bold), rest));
}
export function View(_ref7) {
  var rootClassName = _ref7.rootClassName,
    tag = _ref7.tag,
    rest = _objectWithoutProperties(_ref7, _excluded7);
  var Tag = tag || 'div';
  return /*#__PURE__*/React.createElement(Tag, _extends({}, css(rootClassName, styles.P, styles.weightNormal, styles.fontBody), rest));
}
export function P(_ref8) {
  var rootClassName = _ref8.rootClassName,
    tag = _ref8.tag,
    rest = _objectWithoutProperties(_ref8, _excluded8);
  var Tag = tag || 'p';
  return /*#__PURE__*/React.createElement(Tag, _extends({}, css(rootClassName, styles.P, styles.weightNormal, styles.fontBody), rest));
}
export function Strong(_ref9) {
  var rootClassName = _ref9.rootClassName,
    tag = _ref9.tag,
    rest = _objectWithoutProperties(_ref9, _excluded9);
  var Tag = tag || 'strong';
  return /*#__PURE__*/React.createElement(Tag, _extends({}, css(rootClassName, styles.Strong, styles.weightBold, styles.fontBody), rest));
}
export function Caption(_ref0) {
  var rootClassName = _ref0.rootClassName,
    tag = _ref0.tag,
    rest = _objectWithoutProperties(_ref0, _excluded0);
  var Tag = tag || 'div';
  return /*#__PURE__*/React.createElement(Tag, _extends({}, css(rootClassName, styles.Caption, styles.weightNormal, styles.fontBody), rest));
}
export function Label(_ref1) {
  var rootClassName = _ref1.rootClassName,
    tag = _ref1.tag,
    rest = _objectWithoutProperties(_ref1, _excluded1);
  var Tag = tag || 'label';
  return /*#__PURE__*/React.createElement(Tag, _extends({}, css(rootClassName, styles.Label, styles.weightBold, styles.bold), rest));
}
export function H1Xl(_ref10) {
  var rootClassName = _ref10.rootClassName,
    tag = _ref10.tag,
    rest = _objectWithoutProperties(_ref10, _excluded10);
  var Tag = tag || 'h1';
  return /*#__PURE__*/React.createElement(Tag, _extends({}, css(rootClassName, styles.H1Xl, styles.weightNormal, styles.fontHeadline), rest));
}
export function H1BoldXl(_ref11) {
  var rootClassName = _ref11.rootClassName,
    tag = _ref11.tag,
    rest = _objectWithoutProperties(_ref11, _excluded11);
  var Tag = tag || 'h1';
  return /*#__PURE__*/React.createElement(Tag, _extends({}, css(rootClassName, styles.H1Xl, styles.weightBold, styles.bold), rest));
}
export function H2Bold(_ref12) {
  var rootClassName = _ref12.rootClassName,
    tag = _ref12.tag,
    rest = _objectWithoutProperties(_ref12, _excluded12);
  var Tag = tag || 'h2';
  return /*#__PURE__*/React.createElement(Tag, _extends({}, css(rootClassName, styles.H2, styles.weightBold, styles.bold), rest));
}
export function H1Display(_ref13) {
  var rootClassName = _ref13.rootClassName,
    tag = _ref13.tag,
    rest = _objectWithoutProperties(_ref13, _excluded13);
  var Tag = tag || 'h1';
  return /*#__PURE__*/React.createElement(Tag, _extends({}, css(rootClassName, styles.H1, styles.weightNormal, styles.fontDisplay), rest));
}
export function H1DisplayBoldXl(_ref14) {
  var rootClassName = _ref14.rootClassName,
    tag = _ref14.tag,
    rest = _objectWithoutProperties(_ref14, _excluded14);
  var Tag = tag || 'h1';
  return /*#__PURE__*/React.createElement(Tag, _extends({}, css(rootClassName, styles.H1Xl, styles.weightBold, styles.displayBold), rest));
}